module.exports = __webpack_public_path__ + "img/main_mockup_project.356b0475.png";